import type React from 'react';

import { TextButton } from '@xing-com/button';
import { IconArrowDown, IconArrowUp } from '@xing-com/icons';
import { Headline as Question } from '@xing-com/typography';

import { QuestionBox, Answer } from './accordion-box.styles';

type AccordionBox = {
  data: { question: string; answer: string };
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
};

export const AccordionBox: React.FC<AccordionBox> = ({
  data,
  isOpen,
  setIsOpen,
}) => {
  const { question, answer } = data;

  return (
    <>
      <QuestionBox isOpen={isOpen} onClick={() => setIsOpen(!isOpen)}>
        <Question size="large" noMargin>
          {question}
        </Question>
        {isOpen ? (
          <TextButton icon={IconArrowUp} size="medium" />
        ) : (
          <TextButton icon={IconArrowDown} size="medium" />
        )}
      </QuestionBox>
      {isOpen ? <Answer size="xlarge">{answer}</Answer> : null}
    </>
  );
};
